import { createStyles, rem } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  byWhenDateElem: {
    marginTop: "15px",
  },
  essentialSupportRadio: {
    border: "1px solid var(--app-border)",
    padding: 10,
    borderRadius: "10px",
    width: "200px",
  },
  essentialSupportFieldBox: {
    border: "1px solid var(--app-border)",
    padding: 10,
    borderRadius: "10px",
  },
  essentialActivities: {
    border: "1px solid var(--app-border)",
    width: "100%",
    height: "auto",
    borderRadius: "5px",
    marginTop:"20px"
  },
  oneA: {
    backgroundColor: "var(--app-surface-2)",
    padding: "5px 15px",
  },
  statementAndSupport: {
    padding: "10px 15px",
    backgroundColor: "var(--app-surface-2)",
  },
  statementSupportParent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "15px",
    "@media (max-width:992px)": {
      display: "block",
      textAlign: "-webkit-center",
    },
  },
  statementSupportTextArea: {
    width: "100%",
    backgroundColor: "var(--app-surface-2)",
    borderRadius: "5px",
  },
  supportBox: {
    width: "50%",
    "@media (max-width:992px)": {
      width: "100%",
    },
  },
  instructionsBox: {
    "@media (max-width:992px)": {
      marginTop: "10px",
    },
  },
  addSupportDetails: {
    width: "100%",
    backgroundColor: "var(--app-primary)",
    color: "var(--app-on-primary)",
    borderRadius: "5px",
    fontSize: "small",
    marginTop: "10px",
    padding: "10px 0",
    border: "none",
    cursor: "pointer",
  },
  saveButton: {
    width: "100%",
    backgroundColor: "var(--app-primary)",
    color: "var(--app-on-primary)",
    borderRadius: "5px",
    fontSize: "small",
    marginTop: "10px",
    padding: "15px 0",
    border: "none",
    cursor: "pointer",
  },
  addNewActivityParent: {
    textAlign: "right",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    padding: "10px 0",
  },
  addNewActivity: {
    border: "none",
    backgroundColor: "var(--app-primary)",
    cursor: "pointer",
    color: "var(--app-on-primary)",
    fontSize: "25px",
    fontWeight: "bold",
    borderRadius: "3px",
    marginTop: "10px",
    "&:hover": {
      backgroundColor: "var(--app-primary)",
    },
  },
  addInfo: {
    marginTop: "5px",
  },
  essentialSupportNumberBox:{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "var(--app-surface-2)",
    paddingInline: "10px",
    borderRadius: "5px",
    marginBottom: "10px",
    gap: "10px",
    "@media (max-width: 768px)": {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  }
}));

export default useStyles;
